module.exports = __webpack_public_path__ + "static/media/loopfi.b2165898.svg";